import React from "react";
import { useParams } from "react-router-dom";
import Header from "../Common/Header/Header";
import Sidebar from "../Common/Sidebar/Sidebar";

const FullActionStatisticsDetails = React.memo(() => {
  let { organizationId } = useParams();
  return (
    <div>
      <Header />
      <div>FullActionStatisticsDetails :{organizationId}</div>
      <Sidebar />
    </div>
  );
});

export default FullActionStatisticsDetails;
